import React from 'react'
import './MessageTooltip.css'

class MessageTooltip extends React.Component {
  state = {
    open: this.props.triggerFromOutside ? this.props.open : true,
  }

  componentWillMount(props) {
     if(this.props.closed){
      this.setState(prevState => ({ open: !prevState.open }))
    }
  }

  componentWillUpdate(props) {
    if(props.open !== this.props.open) {
      this.setState({ open: props.open })
    }
  }

  handleClick = e => {
    this.setState(prevState => ({ open: !prevState.open }), () => {
      if(this.props.update)
        this.props.update(this.state.open)
    })
  }



  render() {
    return (
      <div className="Message-tooltip" style={this.props.style}>
        <div className="Message-tooltip-trigger" onClick={this.handleClick}>
          {this.state.open ? (<span>-</span>) : (<span>+</span>)}
        </div>
        {this.state.open &&
          <div className="Message-tooltip-content">
            {this.props.children}
          </div>
        }
      </div>
    )
  }
}

export default MessageTooltip
